import {Exclude, Type} from 'class-transformer';

import {TranslatedText} from 'shared/models/translated-text';
import {AnswerOption} from './answer-option';
import {QuestionType} from './question-type';

export class RatingQuestionType implements QuestionType {
  public name: string = 'rating';
  @Exclude({toPlainOnly: true})
  public prettyName: string = 'Rating';
  @Exclude({toPlainOnly: true})
  public icon: string = 'star-half-o';
  @Type(() => TranslatedText)
  public minText: TranslatedText;
  @Type(() => TranslatedText)
  public maxText: TranslatedText;

  constructor() {
    this.minText = TranslatedText.createEmptyInstance();
    this.maxText = TranslatedText.createEmptyInstance();
  }

  public getAnswerOptions(): Array<AnswerOption> {
    return [
      {label: '1', value: '1'},
      {label: '2', value: '2'},
      {label: '3', value: '3'},
      {label: '4', value: '4'},
      {label: '5', value: '5'},
    ];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/models/questions/rating-question-type.ts